var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSticker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,68A34,34,0,0,1,0,34V30a4.74,4.74,0,0,1,1.29-3.12L26.88,1.29A4.76,4.76,0,0,1,30,0h4a34,34,0,0,1,0,68ZM4,31.75V34A30,30,0,1,0,34,4H31.75A32,32,0,0,1,4,31.75Zm2.61-4.54,20.6-20.6a28,28,0,0,1-20.6,20.6Zm23,6.46,7.67-11.76a2,2,0,0,1,3.36,0l15,23A2,2,0,0,1,54,48H15a2,2,0,0,1-1.7-3.06l10-16a2,2,0,0,1,3.4,0l2.95,4.73ZM36.11,44h14.2L39,26.66,32,37.41ZM25,33.77,18.61,44H31.39Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSticker);
export default __webpack_public_path__ + "static/media/sticker.877fb2e1d8d149084d2ba97170b5286a.svg";
export { ForwardRef as ReactComponent };